import {Component, OnInit} from '@angular/core';
import {UserModel} from '../models/user.model';
import {ActivatedRoute, Router} from '@angular/router';
import {UserIdentity} from '../../helpers/common/user.identity';
import {MessageService} from 'primeng/api';
import {AuthenticationService} from '../../_services';
import {TranslateService} from '@ngx-translate/core';

@Component({
  moduleId: module.id,
  selector: 'app-staff-register',
  templateUrl: `../views/staff-register.component.html`,
  styleUrls: ['../styles/auth-style.scss'],
  providers: [ MessageService ]
})
export class StaffRegisterComponent implements OnInit {
  public user: UserModel;
  hideform = false;
  token = null;
  role = "";

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private translate: TranslateService,
  ) {
    this.user = new UserModel();
    this.token = this.route.snapshot.params.token;
    console.log(this.token);
  }

  ngOnInit() {
    const returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/project';
    if (UserIdentity.isAuthenticated()) {
      this.router.navigate([returnUrl]);
    }
    this.authService.getEmailFromToken(this.token).subscribe(response => {
      if (response.email) {
        // JS-1802: the account already exists (e.g. registered via another
        // pending invitation) — this invite now just adds the membership.
        if (response.existing_user) {
          this.router.navigate(['/join-agency/' + this.token]);
          return;
        }
        this.user.email = response.email;
        this.role = response.role;
        if (response.language) {
          this.translate.use(response.language);
          localStorage.setItem('Language', response.language);
        }
      } else {
          this.translate.get('This link is expired').subscribe(res => {
              this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
          });
      }

    });
  }

  signOut(): void {
    // this.authService.signOut();
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  onSubmit(profileForm) {
    if (!profileForm.valid) {
      return;
    }
    this.user.email = this.user.email.toLowerCase();
    this.register(this.user);
    return;
  }

  register(user) {
    this.authService.staffRegister({...user, token: this.token}).subscribe(response => {
        if (response.status === 'success') {
          // JS-1802: stay on the congratulations screen until the user
          // chooses to continue (same as the join-agency flow).
          this.hideform = true;
        }
      },
      err => {
          this.translate.get('Sorry, you cannot register. Maybe you have not been invited?!').subscribe(res => {
              this.messageService.add({
                  severity: 'error',
                  summary: this.translate.instant('Error!'),
                  detail: res
              });
          });
      });
  }
}
